import { has } from 'lodash';
import { ErrorContent } from 'extensions/widget/store/widget-constants';

type WindowOpenProps = {
    redirectionPath: string;
    name?: string | undefined;
};

export const windowOpen = ({ redirectionPath, name }: WindowOpenProps) => {
    window.open(redirectionPath, name ? name : '_blank');
};

export function isValidWidgetContent<T>(content: T[] | null): content is T[] | null {
    return !(has(content, 'isError') && (content as unknown as ErrorContent).isError);
}
